export const SUCCESS = 'success'
export const INFO = 'info'
export const WARNING = 'warning'
export const DEFAULT = 'default'
export const ERROR = 'error'
export const PRIMARY = 'primary'
